import React from 'react';
import {
    View,
    Text,
    TouchableOpacity,
    TextInput,
    Alert,
    FlatList,
    Image,
    ImageBackground,
    TextProps, ViewProps
} from 'react-native';
import { connect } from 'react-redux';
import IAppState from "../Models/App/IAppState";

import {AnyAction} from "redux";


import {StackNavigationProp} from "@react-navigation/stack";
import { RouteProp } from '@react-navigation/native';
import AppText from "./AppText";
import HideableView from "./HideableView";
import App from "../App";
import ISubClient from "../Models/Client/ISubClient";
import ISubOrder from "../Models/Courier/ISubOrder";
import AppButton from "./AppButton";
import CloseOrderModal from "./CloseOrderModal";
import IOrder from "../Models/IOrder";
import {EOrderStatus} from "../Models/EOrderStatus";


type ProjectsScreenNavigationProp = StackNavigationProp< any, 'Projects'>;
interface IProps {
    subOrder:ISubOrder;
    order:IOrder;
    isOpened?:boolean;
    removeCallBack?:Function
    openingMode?:boolean;
}
interface IState {
    isInfoOpened:boolean;
    isOrderModalShowing:boolean;
}

export default class SubOrderItem extends React.Component<IProps & ViewProps> {

    state:IState={
        isInfoOpened:false,
        isOrderModalShowing:false
    }
    componentDidMount() {

    }
    getImages():any[]{
        let imgs=[];
        if(this.props.subOrder.isRegular){
            imgs.push(require('../assets/regular.png'))
        }
        if(this.props.subOrder.isPackage){
            imgs.push(require('../assets/package.png'))
        }
        if(this.props.subOrder.isMsg){
            imgs.push(require('../assets/mail.png'))
        }
        if(this.props.subOrder.isOutSide){
            imgs.push(require('../assets/outSide.png'))
        }
        if(this.props.subOrder.isCar){
            imgs.push(require('../assets/car.png'))
        }
        if(this.props.subOrder.isExpress){
            imgs.push(require('../assets/express.png'))
        }
        return imgs
    }
    doAction(){
        if(this.props.isOpened){
            this.setState({isOrderModalShowing:true})
            return;
        }
        if(this.props.removeCallBack){
            this.props.removeCallBack(this.props.subOrder.SubClientId)
        }
    }
    render() {
        return(
            <View style={{width:'100%',justifyContent:'center',backgroundColor:'#606060',paddingTop:5,alignItems:'center',borderBottomWidth:0.5,borderBottomColor:'white'}}>
                <View style={{flexDirection:'row',justifyContent:'center',alignItems:'center',paddingLeft:15,paddingRight:15,paddingBottom:5}}>
                    <View style={{flex:0.23,alignItems:'flex-start',justifyContent:'center',paddingTop:5}}>
                        <AppText style={{color:'#fff',fontSize:12,fontWeight:'700',lineHeight:14,textAlign:'left'}}>{this.props.subOrder.SubClient?.name}</AppText>
                    </View>
                    <View style={{flex:0.34,alignItems:'flex-start',justifyContent:'center'}}>
                        <AppText style={{color:'#fff',fontSize:13}}>{this.props.subOrder.SubClient?.address}</AppText>
                    </View>
                    <View style={{flex:0.23,alignItems:'flex-start',justifyContent:'center',height:20}}>
                        <AppText style={{color:'#fff',fontSize:13}}>{this.props.subOrder.SubClient?.phone}</AppText>
                    </View>
                    <View style={{flex:0.2,alignItems:'center'}}>
                        <TouchableOpacity style={{width:70,height:20,backgroundColor:this.state.isInfoOpened?'#01B271':'#019FB2',justifyContent:'center',alignItems:'center',borderRadius:25}} onPress={()=>this.setState({isInfoOpened:!this.state.isInfoOpened})}>
                            <AppText style={{color:'#fff',fontWeight:'500',fontSize:12}}>{'פרטי משלוח'}</AppText>
                        </TouchableOpacity>
                    </View>
                </View>
                <HideableView hidden={!this.state.isInfoOpened} style={{width:'100%',backgroundColor:'white',paddingLeft:10,paddingRight:15,paddingTop:10,paddingBottom:10}}>
                    <View style={{width:'100%',flexDirection:'row'}}>
                        <View >
                            <View style={{width:'100%',flexDirection:'row'}}>
                                {
                                    this.getImages().slice(0,3).map((im)=>{
                                        return   <Image source={im} style={{width:40,height:40,borderColor:'white',marginLeft:5}} />

                                    })
                                }
                            </View>
                            <View style={{width:'100%',flexDirection:'row',marginTop:5}}>
                                {
                                    this.getImages().slice(3,6).map((im)=>{
                                        return   <Image source={im} style={{width:40,height:40,borderColor:'white',marginLeft:5}} />

                                    })
                                }
                            </View>
                        </View>
                        <View style={{marginLeft:5,width:'100%'}}>
                            <View style={{flexDirection:'row',width:'100%'}}>
                                <AppText style={{fontSize:14,fontWeight:'700'}}>{this.props.subOrder.type==0?"איסוף":"פיזור"}</AppText>
                            </View>
                            <View style={{flexDirection:'row',width:'100%'}}>
                                <AppText style={{fontSize:14,fontWeight:'700'}}>הערות:</AppText>
                                <AppText style={{fontSize:14,marginLeft:2}}>{this.props.subOrder.notes}</AppText>
                            </View>


                            <View style={{flexDirection:'row',width:'100%'}}>
                                <AppText style={{fontSize:14,fontWeight:'500'}}>{this.props.subOrder.orderDate.substring(0,10)}</AppText>
                                <AppText style={{fontSize:14,marginLeft:15,fontWeight:'500'}}>{this.props.subOrder.orderTime}</AppText>
                            </View>
                            <HideableView   style={{flexDirection:'row',width:'100%'}} >
                                <AppText style={{fontSize:14,fontWeight:'700'}}>{"שליח:"}</AppText>
                                <AppText style={{fontSize:14,marginLeft:2,fontWeight:'500'}}>{this.props.subOrder.Courier?.name}</AppText>
                            </HideableView>
                            <HideableView style={{width:'100%'}} hidden={this.props.subOrder.status!=EOrderStatus.DELIVERED}>
                                <View style={{flexDirection:'row',width:'100%'}}>
                                    <AppText style={{fontSize:14,fontWeight:'700'}}>חתימת המקבל:</AppText>
                                    <AppText style={{fontSize:14,marginLeft:2}}>{this.props.subOrder.subClientSignImg}</AppText>
                                </View>
                                <View style={{flexDirection:'row',width:'100%'}}>
                                    <AppText style={{fontSize:14,fontWeight:'700'}}>חתימת השליח:</AppText>
                                    <AppText style={{fontSize:14,marginLeft:2}}>{this.props.subOrder.courierSignImg}</AppText>
                                </View>
                            </HideableView>

                        </View>
                    </View>

                    <HideableView hidden={this.props.subOrder.status==EOrderStatus.DELIVERED || this.props.openingMode} style={{justifyContent:'center',alignItems:'center',width:'100%',marginTop:10}}>
                        <AppButton text={'סיכום משלוח'} color={this.props.isOpened?'#01B271':'red'} onPress={()=>this.doAction()} width={100} height={25}/>
                    </HideableView>
                    <View style={{width:'100%',justifyContent:'center',alignItems:'center',marginTop:5}}>
                        <AppButton text={'מחק'} color={'red'} onPress={()=>this.props.removeCallBack?this.props.removeCallBack(this.props.subOrder):null} width={100} height={25}/>
                    </View>
                    <CloseOrderModal show={this.state.isOrderModalShowing} order={this.props.order} subOrder={this.props.subOrder}  closeCallBack={()=>this.setState({isOrderModalShowing:false})}/>
                </HideableView>

            </View>
        );
    }
}

